import { axiosInstanceNewAPI } from '@/services/api/utils/axiosInstance';
import { Chemical, Drug } from '@/types/models';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkConfig } from '@/types/store';
import { getError } from '@/utils/error-report/getError';
import { validateDataUsingZodSchema } from '@/utils/validateDataUsingZodSchema';
import { z } from 'zod';
import { drugSchema } from '@/models/drugSchema';
import { chemicalSchema } from '@/models/chemicalSchema';
import {
  CHEMICALS_FOR_BIO_ENTITY_FETCHING_ERROR_PREFIX,
  DRUGS_FOR_BIO_ENTITY_FETCHING_ERROR_PREFIX,
} from './drawer.constants';
import { apiPath } from '../apiPath';

export const getDrugsForBioEntityDrawerTarget = createAsyncThunk<Drug[], string, ThunkConfig>(
  'drawer/getDrugsForBioEntityDrawerTarget',
  async target => {
    try {
      const response = await axiosInstanceNewAPI.get<Drug[]>(
        apiPath.getDrugsByTargetTarget(target),
      );

      const isDataValid = validateDataUsingZodSchema(response.data, z.array(drugSchema));

      return isDataValid ? response.data : [];
    } catch (error) {
      return Promise.reject(
        getError({ error, prefix: DRUGS_FOR_BIO_ENTITY_FETCHING_ERROR_PREFIX }),
      );
    }
  },
);

export const getChemicalsForBioEntityDrawerTarget = createAsyncThunk<
  Chemical[],
  string,
  ThunkConfig
>('drawer/getChemicalsForBioEntityDrawerTarget', async target => {
  try {
    const response = await axiosInstanceNewAPI.get<Chemical[]>(
      apiPath.getChemicalsByTargetTarget(target),
    );

    const isDataValid = validateDataUsingZodSchema(response.data, z.array(chemicalSchema));

    return isDataValid ? response.data : [];
  } catch (error) {
    return Promise.reject(
      getError({ error, prefix: CHEMICALS_FOR_BIO_ENTITY_FETCHING_ERROR_PREFIX }),
    );
  }
});
